// extracted by css-extract-rspack-plugin
export default {"name":"name-ufQFnP","file":"file-OT8uR4","cell":"cell-ZiLzTN","actions":"actions-eDWSp5"};